import { render, staticRenderFns } from "./referee.vue?vue&type=template&id=1de7d6b0&scoped=true"
import script from "./referee.vue?vue&type=script&lang=js"
export * from "./referee.vue?vue&type=script&lang=js"
import style0 from "./referee.vue?vue&type=style&index=0&id=1de7d6b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1de7d6b0",
  null
  
)

export default component.exports